import axios from 'axios';

import { urlConfig } from "@/constants/urlConfig";
import authHeader from './auth-header';

const API_URL = urlConfig.API_URL;
const API_FILE_URL = urlConfig.API_FILE_URL;

class ProjectService {
  analyzeProject(project) {
      console.log(project);
      return axios
      .post(API_URL + 'projects/analyze', {
        projectName : project.projectName,
        uxActivities : project.uxActivities,
        usedDxComponents: project.usedDxComponents,
        files: project.files,
        decleration : project.decleration
    }, { headers: authHeader() })
    .then(response => {
      if (response.data) {
        localStorage.setItem('project', JSON.stringify(response.data));
      }

      return response.data;
    });;
  }

  deleteFile(id){
    return axios.delete(API_FILE_URL +"/" +id, { headers: authHeader() });
  }
  getReport(id,ruleType){
    return axios.get(API_URL +`projects/reports/${id}?ruleType=${ruleType}`, { headers: authHeader() });
  }
}

export default new ProjectService();